export const mockEnvironment = {
    mockURL : "http://localhost:7373/mock"
  }
  


// WEBPACK FOOTER //
// ./src/app/shared/models/project-constant/constant.ts